// @flow
import { Api as _Api } from '../../common/api/Api';
import { locatePath } from '../../common/RelativeUrl';
import type { Coach as CoachObject, TrialLesson } from '../types';
import { ApiCallable } from '../../common/api/ApiCallable';
export { initCsrfConfig } from '../../common/api/Api';

const Base = new _Api(locatePath('/api/v1'), '');
export const CurrentUser = Base.appendPath('/users/current');
export const CurrentUserPreference = CurrentUser.appendPath('preference');
export const Lessons = Base.appendPath('/lessons');
export const Coaches = Base.appendPath('/coaches');
export const Faqs = Base.appendPath('/faqs_with_categories');
export const Coach = Coaches.appendPath(':coachId');
export const CoachLessons = Coach.appendPath('/coach_lessons');
export const PastLessons = Lessons.addParams({ past: true });
export const RecommendedLessons = Base.appendPath('/recommended_lessons');
export const LessonReserve = Lessons.appendPath(':lessonId/reserve');
export const Memberships = Base.appendPath('/memberships');
export const MembershipCurrent = Memberships.appendPath('current');
export const MembershipTickets = Memberships.appendPath('current/tickets');
export const MembershipCurrentCard = Memberships.appendPath('current/card');
export const Reservations = Base.appendPath('/reservations');
export const Reservation = Reservations.appendPath(':reservationId');
export const SignOut = Base.appendPath('/users/sign_out');
export const SignIn = Base.appendPath('/users/sign_in');
export const SignUp = Base.appendPath('/users/new');
export const Api = {
    CurrentUser,
    Lessons,
    Coaches,
    Faqs,
    PastLessons,
    RecommendedLessons,
    LessonReserve,
    SignOut,
    SignIn,
    SignUp,
    Memberships,
    MembershipCurrent,
    MembershipTickets,
    MembershipCurrentCard,
    Reservations,
    Reservation,
};

export const CoachApis = {
    findCoachByName(name: string): ApiCallable<CoachObject> {
        return Coaches.appendPath('by_name').toGetCallable({ name });
    },
};
